import { render, staticRenderFns } from "./ViewBuilding.vue?vue&type=template&id=21f7f61c"
import script from "./ViewBuilding.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBuilding.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports